import './product.scss';
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiClient from '../../../../utils/apiClient';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {useTranslation} from "react-i18next";
import decodeToken from "../../../../utils/decode-token";
import MediaTextBlock from '../media-text-block';

const Product = () => {
  const token = sessionStorage.getItem('token') || null;
  const location = useLocation();
  const {t} = useTranslation();
  const role = decodeToken(token).role;

  const id = location.state?.id || '';
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    const fetchItem = async () => {
      try {
        const res = await apiClient.get(`/cms/item/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setProductData(res.data);
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    };

    if (id) fetchItem();
  }, [id, token]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
  };

  if (!token) return <Navigate to="/login" />;
  if (!productData) return null; // o un loader

  const {
    main_image,
    intro_title,
    intro_body,
    content_title,
    content_subtitle,
    content_body_1,
    content_image_1,
    content_bottom,
    carrousel = [],
  } = productData;

  return (
    <>
      <section className="hero" style={{ backgroundImage: `url(${main_image})` }}></section>

      <section className="title dark">
        <div className="inner">
          <h1>
            {intro_title}
            {intro_body && (
              <small>{intro_body}</small>
            )}
          </h1>
          <span className="icon-arrow-down"></span>
        </div>
      </section>

      <section className="info">
        <div className="inner">
          <div className="intro">
            {content_title && <h2>{content_title}</h2>}
            {content_subtitle && <p className="full-width">{content_subtitle}</p>}
          </div>

          {(content_body_1 || content_image_1) && (
            <MediaTextBlock image={content_image_1} textHtml={content_body_1} />
          )}

          {(content_bottom) && (
            <div >
              <p className="full-width" dangerouslySetInnerHTML={{__html: content_bottom}}></p>
            </div>
          )}
        </div>
      </section>

      {carrousel.length > 0 && (
        <section className="slider">
          <div className="inner">
            <Slider {...sliderSettings}>
              {[...carrousel]
                .sort((a, b) => a.priority - b.priority)
                .map((item, idx) => (
                  <div key={idx}>
                    <img src={item.image} alt={`slide-${idx}`} />
                  </div>
                ))}
            </Slider>
          </div>
        </section>
      )}

      {role === 'hac' && (
        <footer className="footer-contact">
          <div className="inner">
            <h2>{t('limitededition-footer-title')}</h2>
            <p>{t('limitededition-footer-text')}</p>
            <p>
              <button className="btn fit">
                <span className="text">{t('common-contact-assistant')}</span>
              </button>
            </p>
          </div>
        </footer>
      )}
    </>
  );
};

export default Product;
